export const blockIconsTextformattingPendingActionsNew = (
	<span className='material-symbols-outlined'>pending_actions</span>
);
